function InfoWish () {
    return (
        <div className='max-w-[1240px] mx-auto py-16 px-4'>
            <h1 className='py-2 text-center text-indigo-300 '>Wishlist</h1>
            <hr className='py-4  border-gray-300' style={{ color: '#14b8a6' }} />
            <div className="text-center">
                <p>Vas a tener la posibilidad de agregar productos a una Wishlist para poder navegar por toda nuestra aplicacion sin perderte ni olvidarte de nada.</p>
                <p> No te olvides de registrarte!</p>
            </div>
        </div>
    )
}

export default InfoWish